export const EventName = '::COLLECT_ERROR_EVENT::'

/**
 * @typedef {
 *     'REQUEST_TIMEOUT' | 'REQUEST_SLOW_NETWORK' |'REQUEST_FAIL' |
 *     'WINDOW_ERROR' | 'WINDOW_RUN_ERROR' |
 *     'PROMISE_UNSOLVED' |
 *     'CONSOLE_ERROR' |
 *     'UNKNOWN_ERROR' |
 *     'TEST'
 * } ErrorType
 * */

/**
 * @param {ErrorType} eventData.error_type */

export const DispatchErrorCollectEvent = (eventData = {}) => {
    const ErrorCollectEvent = new CustomEvent(EventName, {
        detail: {
            ...eventData,
            error_time: new Date().getTime(),
        },
        bubbles: false,
        cancelable: true,
    })
    if (window.dispatchEvent) {
        window.dispatchEvent(ErrorCollectEvent)
    } else if (window.fireEvent) {
        window.fireEvent(ErrorCollectEvent)
    }
}
